import PropTypes from "prop-types";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
import { Button, Collapse, ListItem, Typography } from "@mui/material";
import TypeWrapper from "../../../utils/TypeWrapper";

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  ...rest
}) => {
  const location = useLocation();
  const [open, setOpen] = useState(openProp);

  const isActive = location?.path === href;

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const buttonStyles = {
    width: "92%",
    letterSpacing: 0,
    fontWeight: "400",
    marginBottom: "8px",
    color: "primary.main",
    textTransform: "none",
    justifyContent: "flex-start",
    "&:hover": {
      borderRadius: "10px",
      color: TypeWrapper.COLORS.HX_WHITE,
      backgroundColor: TypeWrapper.COLORS.BTN_THEME,
    },
  };
  const buttonLeafStyles = {
    width: "92%",
    letterSpacing: 0,
    fontSize: "14px",
    fontWeight: "400",
    marginBottom: "5px",
    padding: "13px 20px",
    borderRadius: "10px",
    textTransform: "none",
    justifyContent: "center",
    color: TypeWrapper.COLORS.HX_WHITE,
    // color: isActive
    //   ? TypeWrapper.COLORS.HX_WHITE
    //   : TypeWrapper.COLORS.BTN_IN_ACTIVE_TXT,
    // backgroundColor: isActive ? TypeWrapper.COLORS.BTN_THEME : "transparent",
    backgroundColor: TypeWrapper.COLORS.BTN_THEME,
    "&:hover": {
      borderRadius: "10px",
      color: "#fff !important",
      backgroundColor: TypeWrapper.COLORS.BTN_THEME,
    },
    "&.depth-0": {
      fontSize: "13px",
      fontWeight: "400",
      lineHeight: "17px",
      fontFamily: "Sora, sans-serif",
    },
  };
  const iconStyles = {
    marginLeft: 1,
    marginRight: 2,
    display: "flex",
    alignItems: "center",
    // color: isActive
    //   ? TypeWrapper.COLORS.HX_WHITE
    //   : TypeWrapper.COLORS.BTN_IN_ACTIVE_TXT,
    color: TypeWrapper.COLORS.HX_WHITE,
    "&:hover": { color: TypeWrapper.COLORS.HX_WHITE },
  };
  const titleStyles = {
    fontSize: 15,
    color: "inherit",
    marginRight: "auto",
    fontWeight: "500",
    fontFamily: "'Poppins', sans-serif",
  };

  if (children) {
    return (
      <ListItem className={className} disableGutters key={title} {...rest}>
        <Button sx={buttonStyles} onClick={handleToggle}>
          {Icon && <Icon sx={iconStyles} />}
          <Typography sx={titleStyles}>{title}</Typography>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      className={`${className} depth-${depth}`}
      disableGutters
      key={title}
      {...rest}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Button
        exact
        to={href}
        sx={buttonLeafStyles}
        component={RouterLink}
        // style={{ marginTop: -10 }}
      >
        {Icon && <Icon sx={iconStyles} />}
        <Typography sx={titleStyles}>{title}</Typography>
        {Info && <Info />}
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  open: false,
};

export default NavItem;
